import type { ReactNode, ComponentType, SVGProps } from 'react'
import { cn } from '../../helpers/classnames'

export interface JosefEmptyStateProps {
  icon?: ComponentType<SVGProps<SVGSVGElement>>
  iconNode?: ReactNode
  title: string
  description?: string
  action?: ReactNode
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export function JosefEmptyState({
  icon: Icon,
  iconNode,
  title,
  description,
  action,
  className,
  size = 'md',
}: JosefEmptyStateProps) {
  const iconSizes = {
    sm: 'w-10 h-10',
    md: 'w-16 h-16',
    lg: 'w-20 h-20',
  }

  const iconInnerSizes = {
    sm: 'w-5 h-5',
    md: 'w-8 h-8',
    lg: 'w-10 h-10',
  }

  const titleSizes = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
  }

  const descSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-sm',
  }

  const paddingSizes = {
    sm: 'py-6',
    md: 'py-12',
    lg: 'py-16',
  }

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        paddingSizes[size],
        className
      )}
    >
      {(Icon || iconNode) && (
        <div
          className={cn(
            'rounded-full bg-neutral-100 dark:bg-neutral-800 flex items-center justify-center mb-4',
            iconSizes[size]
          )}
        >
          {iconNode ?? (Icon && (
            <Icon
              className={cn(
                'text-neutral-400 dark:text-neutral-500',
                iconInnerSizes[size]
              )}
            />
          ))}
        </div>
      )}
      <h3
        className={cn(
          'font-semibold text-neutral-900 dark:text-white mb-1',
          titleSizes[size]
        )}
      >
        {title}
      </h3>
      {description && (
        <p
          className={cn(
            'text-neutral-500 dark:text-neutral-400 max-w-sm',
            descSizes[size]
          )}
        >
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
